if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}






// if (!customElements.get('media-gallery')) {
//   customElements.define('media-gallery', class MediaGallery extends HTMLElement {
//     constructor() {
//       super();

//       this.elements = {
//         liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//         viewer: this.querySelector('[id^="GalleryViewer"]'),
//         thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
//       };

//       this.mql = window.matchMedia('(min-width: 750px)');
//       if (!this.elements.thumbnails) return;

//       // Store the first media element
//       this.firstMedia = null;

//       // On page load, initialize the gallery
//       window.addEventListener('load', () => {
//         this.initializeGallery();
//       });

//       // Listen for variant change (assuming there’s an event or method to handle this)
//       this.addEventListener('variantChanged', () => {
//         this.initializeGallery(); // Reinitialize gallery when variant changes
//       });

//       this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//       this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//         mediaToSwitch.querySelector('button').addEventListener('click', (event) => {
//           // Detect if it's the last thumbnail and apply custom behavior
//           if (this.isLastThumbnail(mediaToSwitch)) {
//             this.handleLastThumbnailClick(event, mediaToSwitch);
//           } else {
//             this.setActiveMedia(mediaToSwitch.dataset.target, false, true);
//           }
//         });
//       });

//       if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
//     }

//     initializeGallery() {
//       // Ensure that both media are initialized correctly
//       const firstMedia = this.elements.viewer.querySelector('[data-media-id]');
//       if (firstMedia) {
//         this.firstMedia = firstMedia; // Store the first media
//         this.setActiveMedia(firstMedia.dataset.mediaId, false, false); // Set the first media as active
//       }

//       // Ensure the second media is marked correctly
//       const activeMedia = this.elements.viewer.querySelector('.is-active');
//       const nextMedia = activeMedia ? activeMedia.nextElementSibling : null;
//       if (nextMedia) {
//         nextMedia.classList.add('is-active');
//       }
//     }

//     onSlideChanged(event) {
//       if (event.detail.currentElement == undefined) return;

//       const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
//       this.setActiveThumbnail(thumbnail);
//     }

//     setActiveMedia(mediaId, prepend, scrollIntoView = true) {
//       const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);

//       // Get the next media element
//       let nextMedia = activeMedia.nextElementSibling;
//       if (!nextMedia) {
//         nextMedia = this.elements.viewer.querySelector('[data-media-id]'); // fallback if no next media
//       }

//       let datamediapostion = this.elements.viewer.querySelector('[data-media-position]').val;
//       console.log(datamediapostion, "datamediapostion");

//       // Reset all media items first
//       this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//         element.classList.remove('is-active');
//       });

//       // Mark the current media as active
//       activeMedia.classList.add('is-active');
      
//       // Mark the next media as active as well
//       nextMedia.classList.add('is-active');

//       // Optionally, if you need to prepend media, handle that logic as you currently have
//       if (prepend) {
//         activeMedia.parentElement.prepend(activeMedia);
//         if (this.elements.thumbnails) {
//           const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//           activeThumbnail.parentElement.prepend(activeThumbnail);
//         }
//         if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//       }

//       this.preventStickyHeader();
//       window.setTimeout(() => {
//         if (this.elements.thumbnails) {
//           activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//         }
//         if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
//           activeMedia.scrollIntoView({behavior: 'smooth'});
//         }
//       });

//       this.playActiveMedia(activeMedia);

//       if (!this.elements.thumbnails) return;
//       const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//       this.setActiveThumbnail(activeThumbnail);
//       this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//     }

//     setActiveThumbnail(thumbnail) {
//       if (!this.elements.thumbnails || !thumbnail) return;

//       this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
//         element.classList.remove('is-active');
//         element.querySelector('button').removeAttribute('aria-current');
//       });
//       thumbnail.classList.add('is-active');
//       thumbnail.querySelector('button').setAttribute('aria-current', true);

//       if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//       this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//     }

//     announceLiveRegion(activeItem, position) {
//       const image = activeItem.querySelector('.product__modal-opener--image img');
//       if (!image) return;
//       image.onload = () => {
//         this.elements.liveRegion.setAttribute('aria-hidden', false);
//         this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
//           '[index]',
//           position
//         );
//         setTimeout(() => {
//           this.elements.liveRegion.setAttribute('aria-hidden', true);
//         }, 2000);
//       };
//       image.src = image.src;
//     }

//     playActiveMedia(activeItem) {
//       window.pauseAllMedia();
//       const deferredMedia = activeItem.querySelector('.deferred-media');
//       if (deferredMedia) deferredMedia.loadContent(false);
//     }

//     preventStickyHeader() {
//       this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//       if (!this.stickyHeader) return;
//       this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//     }

//     removeListSemantic() {
//       if (!this.elements.viewer.slider) return;
//       this.elements.viewer.slider.setAttribute('role', 'presentation');
//       this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
//     }

//     isLastThumbnail(thumbnail) {
//       // Determine if this thumbnail is the last one
//       return thumbnail === this.elements.thumbnails.querySelectorAll('[data-target]').length - 1;
//     }

//     handleLastThumbnailClick(event, thumbnail) {
//       // Check if first media is stored
//       if (!this.firstMedia) return;

//       // Now, we need to make the stored first media as the second media
//       const firstMedia = this.firstMedia;

//       // Set the stored first media as the second media
//       if (firstMedia) {
//         const secondMedia = firstMedia.nextElementSibling;
//         this.setActiveMedia(firstMedia.dataset.mediaId, false, false);

//         if (secondMedia) {
//           this.setActiveMedia(secondMedia.dataset.mediaId, false, false);
//         }
//       }

//       // Adjust the thumbnails
//       const firstThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ firstMedia.dataset.mediaId }"]`);
//       const secondThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ firstMedia.nextElementSibling.dataset.mediaId }"]`);

//       // Swap their positions in the thumbnail list
//       if (firstThumbnail && secondThumbnail) {
//         firstThumbnail.parentElement.insertBefore(secondThumbnail, firstThumbnail);
//       }
//     }
//   });
// }
// if (!customElements.get('media-gallery')) {
//   customElements.define('media-gallery', class MediaGallery extends HTMLElement {
//     constructor() {
//       super();

//       this.elements = {
//         liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//         viewer: this.querySelector('[id^="GalleryViewer"]'),
//         thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
//       };

//       this.mql = window.matchMedia('(min-width: 750px)');
//       if (!this.elements.thumbnails) return;

//       // Store the first media element
//       this.firstMedia = null;

//       // On page load, initialize the gallery
//       window.addEventListener('load', () => {
//         this.initializeGallery();
//       });

//       // Listen for variant change (assuming there’s an event or method to handle this)
//       this.addEventListener('variantChanged', () => {
//         this.initializeGallery(); // Reinitialize gallery when variant changes
//       });

//       this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//       this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//         mediaToSwitch.querySelector('button').addEventListener('click', (event) => {
//           // Detect if it's the last thumbnail and apply custom behavior
//           if (this.isLastThumbnail(mediaToSwitch)) {
//             this.handleLastThumbnailClick(event, mediaToSwitch);
//           } else {
//             this.setActiveMedia(mediaToSwitch.dataset.target, false, true);
//           }
//         });
//       });

//       if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
//     }

//     initializeGallery() {
//       // Ensure that both media are initialized correctly
//       const firstMedia = this.elements.viewer.querySelector('[data-media-id]');
//       if (firstMedia) {
//         this.firstMedia = firstMedia; // Store the first media
//         this.setActiveMedia(firstMedia.dataset.mediaId, false, false); // Set the first media as active
//       }

//       // Ensure the second media is marked correctly
//       const activeMedia = this.elements.viewer.querySelector('.is-active');
//       const nextMedia = activeMedia ? activeMedia.nextElementSibling : null;
//       if (nextMedia) {
//         nextMedia.classList.add('is-active');
//       }
//     }

//     onSlideChanged(event) {
//       if (event.detail.currentElement == undefined) return;

//       const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
//       this.setActiveThumbnail(thumbnail);
//     }

//     setActiveMedia(mediaId, prepend, scrollIntoView = true) {
//       const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);

//       // Get the next media element
//       let nextMedia = activeMedia.nextElementSibling;
//       if (!nextMedia) {
//         nextMedia = this.elements.viewer.querySelector('[data-media-id]'); // fallback if no next media
//       }

//       let datamediapostion = this.elements.viewer.querySelector('[data-media-position]').val;
//       console.log(datamediapostion, "datamediapostion");

//       // Reset all media items first
//       this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//         element.classList.remove('is-active');
//       });

//       // Mark the current media as active
//       activeMedia.classList.add('is-active');
      
//       // Mark the next media as active as well
//       nextMedia.classList.add('is-active');

//       // Optionally, if you need to prepend media, handle that logic as you currently have
//       if (prepend) {
//         activeMedia.parentElement.prepend(activeMedia);
//         if (this.elements.thumbnails) {
//           const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//           activeThumbnail.parentElement.prepend(activeThumbnail);
//         }
//         if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//       }

//       this.preventStickyHeader();
//       window.setTimeout(() => {
//         if (this.elements.thumbnails) {
//           activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//         }
//         if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
//           activeMedia.scrollIntoView({behavior: 'smooth'});
//         }
//       });

//       this.playActiveMedia(activeMedia);

//       if (!this.elements.thumbnails) return;
//       const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//       this.setActiveThumbnail(activeThumbnail);
//       this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//     }

//     setActiveThumbnail(thumbnail) {
//       if (!this.elements.thumbnails || !thumbnail) return;

//       this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
//         element.classList.remove('is-active');
//         element.querySelector('button').removeAttribute('aria-current');
//       });
//       thumbnail.classList.add('is-active');
//       thumbnail.querySelector('button').setAttribute('aria-current', true);

//       if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//       this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//     }

//     announceLiveRegion(activeItem, position) {
//       const image = activeItem.querySelector('.product__modal-opener--image img');
//       if (!image) return;
//       image.onload = () => {
//         this.elements.liveRegion.setAttribute('aria-hidden', false);
//         this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
//           '[index]',
//           position
//         );
//         setTimeout(() => {
//           this.elements.liveRegion.setAttribute('aria-hidden', true);
//         }, 2000);
//       };
//       image.src = image.src;
//     }

//     playActiveMedia(activeItem) {
//       window.pauseAllMedia();
//       const deferredMedia = activeItem.querySelector('.deferred-media');
//       if (deferredMedia) deferredMedia.loadContent(false);
//     }

//     preventStickyHeader() {
//       this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//       if (!this.stickyHeader) return;
//       this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//     }

//     removeListSemantic() {
//       if (!this.elements.viewer.slider) return;
//       this.elements.viewer.slider.setAttribute('role', 'presentation');
//       this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
//     }

//     isLastThumbnail(thumbnail) {
//       // Determine if this thumbnail is the last one
//       return thumbnail === this.elements.thumbnails.querySelectorAll('[data-target]').length - 1;
//     }

//     handleLastThumbnailClick(event, thumbnail) {
  
//       if (!this.firstMedia) return;

//       const firstMedia = this.firstMedia;

//       if (firstMedia) {
//         const secondMedia = firstMedia.nextElementSibling;
//         this.setActiveMedia(firstMedia.dataset.mediaId, false, false);

//         if (secondMedia) {
//           this.setActiveMedia(secondMedia.dataset.mediaId, false, false);
//         }
//       }

//       const firstThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ firstMedia.dataset.mediaId }"]`);
//       const secondThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ firstMedia.nextElementSibling.dataset.mediaId }"]`);

//       if (firstThumbnail && secondThumbnail) {
//         firstThumbnail.parentElement.insertBefore(secondThumbnail, firstThumbnail);
//       }
//     }
//   });
// }




